// main.ts
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/legacy.css'
import '@/assets/css/overrides.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import '@/assets/css/custom.css'

import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'

import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'


import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/store/auth'
import { loadRuntimeConfig } from './runtimeConfig'

// extend Window interface for global property
declare global {
  interface Window {
    IS_DEV: boolean
  }
}

// load env FIRST, expose a global, then mount
;(async () => {
  try {
    const cfg = await loadRuntimeConfig()
    window.IS_DEV = cfg.APP_ENV === 'development'
    console.log('Runtime APP_ENV =', cfg.APP_ENV, 'IS_DEV =', window.IS_DEV)
  } catch {
    window.IS_DEV = false
    console.log('Runtime APP_ENV fetch failed; defaulting IS_DEV = false')
  }

  const root = document.documentElement
  root.setAttribute('dir', 'rtl')
  root.setAttribute('lang', 'ar')
  document.body.setAttribute('dir', 'rtl')
  document.body.classList.add('rtl')

  const app = createApp(App)
  const pinia = createPinia()
  app.use(pinia)
  const auth = useAuthStore(pinia)

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status
      if (status === 401) {
        const wasLoggedIn = auth.isLoggedIn
        if (wasLoggedIn) {
          auth.logout()
        }
        if (router.currentRoute.value.path !== '/login') {
          router.push('/login').catch(() => {})
        }
        if (wasLoggedIn && !error?.response?.data?.detail) {
          if (!error.response) error.response = { data: {} } as any
          error.response.data.detail = 'انتهت صلاحية الجلسة، يرجى تسجيل الدخول مجدداً.'
        }
      }
      return Promise.reject(error)
    }
  )

  app.use(PrimeVue, { ripple: true, theme: {
    preset: Aura,
    options: { darkModeSelector: '.dark-mode', cssLayer: true }
  }})
  app.use(ToastService)
  app.use(ConfirmationService)

  app.use(router)

  // hydrate auth before first navigation
  auth.hydrate()

  app.mount('#app')
})()
